// Anonymous demo landing — creates a guest user + session and drops you straight into a scenario.
import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { api } from '../lib/api';

export default function Try() {
  const nav = useNavigate();
  const [err, setErr] = useState<string | null>(null);
  const [status, setStatus] = useState('Setting up your demo…');

  useEffect(() => {
    setStatus('Creating guest account…');
    api.startDemo()
      .then(({ scenario_id, display_name }) => {
        setStatus(`You're signed in as ${display_name}. Loading scenario…`);
        setTimeout(() => nav(`/scenario/${scenario_id}?demo=1`), 600);
      })
      .catch((e) => setErr(e.message || 'Could not start demo. Try refreshing.'));
  }, [nav]);

  return (
    <div className="max-w-md mx-auto px-4 py-24 text-center">
      <h1 className="text-2xl font-semibold mb-2">ALS Sim · 5-minute taster</h1>
      <p className="text-mono-white/60 text-sm mb-8">No signup. Your progress in this demo isn't permanently saved.</p>
      {err ? (
        <div className="panel p-4 text-alarm-red text-sm">{err}</div>
      ) : (
        <div className="panel p-4 text-mono-white/70 text-sm">{status}</div>
      )}
    </div>
  );
}
